import React from "react";
import Dittes from "./Dittes";

function Kegeln() {
  return (
    <Dittes
      calendarSlug="kegeln"
      pageTitle="Buchungskalender ESV-Bludenz"
      pageSubtitle="Sektion Kegeln"
      fallbackName="Buchungskalender ESV-Bludenz Sektion Kegeln"
    />
  );
}

export default Kegeln;
